export const PERMISSION = Object.freeze({
    VIEW: "view",
    VIEW_OWN: "view-own",
    VIEW_ASSIGNEE: "view-assignee",
    INSERT: "insert",
    INSERT_OWN: "insert-own",
    INSERT_ASSIGNEE: "insert-assignee",
    UPDATE: "update",
    UPDATE_ASSIGNEE: "update-assignee",
    UPDATE_OWN: "update-own",
    DELETE: "delete",
    DELETE_OWN: "delete-own",
})